import React from "react";
import NotificationsActiveOutlinedIcon from "@mui/icons-material/NotificationsActiveOutlined";
import { getNotificationDotColor } from "../utils/notificationColors";

const safe = (value) => String(value || "").trim();

const formatTimeLabel = (createdAt, timezone) => {
  if (createdAt) {
    const parsed = Date.parse(String(createdAt));
    if (!Number.isNaN(parsed)) {
      const base = new Intl.DateTimeFormat("en-IN", {
        day: "2-digit",
        month: "short",
        hour: "2-digit",
        minute: "2-digit",
      }).format(new Date(parsed));
      return timezone ? `${base} ${timezone}` : base;
    }
    return timezone ? `${createdAt} ${timezone}` : String(createdAt);
  }

  const now = new Intl.DateTimeFormat("en-IN", {
    hour: "2-digit",
    minute: "2-digit",
  }).format(new Date());
  return timezone ? `${now} ${timezone}` : now;
};

export default function NotificationToast({
  title,
  body,
  data,
}) {
  const accentColor = getNotificationDotColor(title || data?.title || data?.type || "");
  const iconBg = `${accentColor}1A`;
  const timestamp = formatTimeLabel(data?.created_at, data?.timezone);

  const projectValue = safe(data?.project_name);
  const equipmentValue =
    safe(data?.equipment_name) ||
    safe(data?.equipment_no) ||
    safe(data?.equipment_number);
  const typeValue = safe(data?.type);
  const priorityValue = safe(data?.priority);
  const raisedByValue = safe(data?.raised_by);

  const hasTopMetaRow = projectValue || equipmentValue;
  const hasMiddleMetaRow = typeValue || priorityValue;
  const hasBottomMetaRow = raisedByValue;

  return (
    <div className="notification-toast-card">
      <div className="notification-toast-main">
        <div className="notification-toast-head">
          <div
            className="notification-toast-iconbox"
            style={{ backgroundColor: iconBg, color: accentColor }}
          >
            <NotificationsActiveOutlinedIcon fontSize="small" />
          </div>
          <div className="notification-toast-title-wrap">
            <div className="notification-toast-title">{title || "Notification"}</div>
            <div className="notification-toast-time">{timestamp}</div>
          </div>
        </div>

        {body ? <div className="notification-toast-body">{body}</div> : null}

        {(hasTopMetaRow || hasMiddleMetaRow || hasBottomMetaRow) && (
          <div className="notification-toast-meta-grid">
            {hasTopMetaRow && (
              <div className="notification-toast-meta-row">
                <div className="notification-toast-meta-item">
                  <span className="notification-toast-meta-label">Project:</span>
                  <span className="notification-toast-meta-value">{projectValue || "-"}</span>
                </div>
                <span className="notification-toast-meta-sep">|</span>
                <div className="notification-toast-meta-item">
                  <span className="notification-toast-meta-label">Equipment:</span>
                  <span className="notification-toast-meta-value">{equipmentValue || "-"}</span>
                </div>
              </div>
            )}

            {hasMiddleMetaRow && (
              <div className="notification-toast-meta-row">
                <div className="notification-toast-meta-item">
                  <span className="notification-toast-meta-label">Type:</span>
                  <span className="notification-toast-meta-value">{typeValue || "-"}</span>
                </div>
                <span className="notification-toast-meta-sep">|</span>
                <div className="notification-toast-meta-item">
                  <span className="notification-toast-meta-label">Priority:</span>
                  <span className="notification-toast-meta-value">{priorityValue || "-"}</span>
                </div>
              </div>
            )}

            {hasBottomMetaRow && (
              <div className="notification-toast-meta-row notification-toast-meta-row-single">
                <div className="notification-toast-meta-item">
                  <span className="notification-toast-meta-label">Raised by:</span>
                  <span className="notification-toast-meta-value">{raisedByValue}</span>
                </div>
              </div>
            )}
          </div>
        )}
      </div>
    </div>
  );
}
